import { UserNotification } from "./user-notification.model";

export class NotificationGroup {
    notificationDay: string;
    notifications: Array<UserNotification>;

    constructor() {
        this.notifications = new Array<UserNotification>();
    }
}